import { render, staticRenderFns } from "./BookingConfirmationModal.vue?vue&type=template&id=59f8e0c0&scoped=true"
import script from "./BookingConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./BookingConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./BookingConfirmationModal.vue?vue&type=style&index=0&id=59f8e0c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f8e0c0",
  null
  
)

export default component.exports